<template>
    <div class="custom-admin" style="width: 100%;height: 100%;">
      <customIndex v-if="changeRouter === 'admin'"></customIndex>
      <szIndex v-else-if="changeRouter === 'szzhwy'"></szIndex>
    </div>
</template>

<script>
    import {
        getItem
    } from '@/utils/auth'
    import customIndex from '@/page/customIndex/index/index'
    import szIndex from '@/page/customIndex/szIndex/index'
    export default {
        name: 'customindex',
        data() {
            return {
              changeRouter: ""
            }
        },
        components: {
            customIndex,
            szIndex
        },
        mounted() {
          if (getItem('userInfo').positionType === '2') {
              this.$message({
                  message: '抱歉，此账号暂无权限',
                  type: 'warning',
                  duration: 2000,
                  onClose() {
                      window.history.back(-1);
                  }
              });
          } else {
            if (getItem('userInfo').screenType && getItem('userInfo').screenType === "szzhwy") {
              this.changeRouter = "szzhwy"
            } else {
              this.changeRouter = "admin"
            }
          }
        },
    }
</script>



// WEBPACK FOOTER //
// src/page/customIndex/index.vue